import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../FormBase';
import CancelPurchaseForm from './CancelPurchaseForm';
import CancelPurchaseFormDebit from './CancelPurchaseFormDebit';
import { initialStateDebit, makeInitialState } from './validation/initialState';
import { schema, schemaDebit } from './validation/schema';
import CancelColorIcon from '../../../../../../common/icons/icr_terminos.svg';

const CancelPurchase = ({ ...props }) => {
  const { mobile, product, motiveId, type, profile, initialMessage } = props;
  const [data, setData] = useState({});
  const [paymentMethod, setPaymentMethod] = useState({
    value: '',
    name: 'paymentMethod',
  });
  const [state, setState] = useState({});

  const handleData = (data) => {
    setData(data);
  };

  const handlePaymentMethod = (paymentMethod) => {
    setPaymentMethod(paymentMethod);
  };

  const handleState = (innerState) => {
    setState(innerState);
  };

  const generateExtraData = (innerState) => {
    if (innerState) {
      return {
        medio_pago: innerState?.paymentMethod?.value || '',
        banco: innerState?.bankOption?.value || '',
        numero_cuenta: innerState?.accountNumber?.value || '',
        direccion_anula: innerState?.accountAddress?.value || '',
      };
    }
  };

  return (
    <React.Fragment>
      {paymentMethod.value !== 'Tarjeta de débito' && (
        <FormBase
          mobile={mobile}
          title="Selecciona el medio de pago con el que realizaste tu compra:"
          initialState={makeInitialState(paymentMethod.value)}
          data={paymentMethod.value !== '' ? paymentMethod : ''}
          schema={schema}
          formName={'CancelPurchaseRegular'}
          onState={handleState}
          product={product}
          motiveId={motiveId}
          type={type}
          profile={profile}
          motiveTitle="Anular compra"
          motiveSubtitle="Anular compra"
          motiveIcon={CancelColorIcon}
          extraData={generateExtraData(state)}
          initialMessage={initialMessage}
          form={
            <CancelPurchaseForm
              onData={handleData}
              onPayment={handlePaymentMethod}
              stateData={state}
              paymentData={paymentMethod.value}
            />
          }
        />
      )}
      {paymentMethod.value === 'Tarjeta de débito' && (
        <FormBase
          mobile={mobile}
          title="Selecciona el medio de pago con el que realizaste tu compra:"
          initialState={initialStateDebit}
          data={data}
          schema={schemaDebit}
          formName={'CancelPurchaseDebit'}
          onState={handleState}
          product={product}
          motiveId={motiveId}
          type={type}
          profile={profile}
          motiveTitle="Anular compra"
          motiveSubtitle="Anular compra"
          motiveIcon={CancelColorIcon}
          extraData={generateExtraData(state)}
          initialMessage={initialMessage}
          form={
            <CancelPurchaseFormDebit
              onData={handleData}
              onPayment={handlePaymentMethod}
              stateData={state}
            />
          }
        />
      )}
    </React.Fragment>
  );
};

CancelPurchase.propTypes = {
  mobile: PropTypes.bool,
  product: PropTypes.object,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  profile: PropTypes.object,
  initialMessage: PropTypes.string,
};

export default CancelPurchase;
